module.exports = __webpack_public_path__ + "fonts/97e605188e5281cc0c0483fc6c0fc3c5.txt";